import React from "react";
import { Link } from "react-router-dom";
import { Ticket, ArrowRight } from "lucide-react";
import { trackCrossSellClick } from "../lib/crosssell";

const showDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short" });
  } catch {
    return "";
  }
};

export const CrossSellCard = ({ otherShows = [], sectionName = null, sectionId = null, sourceEventId = null, placement = "event_panel" }) => {
  const avail = (otherShows || []).filter((s) => s.has_availability);
  if (avail.length === 0) return null;

  // Section-aware preference: stable id first, then name; fallback = soonest available sibling
  let pick = null;
  let sectionMatch = false;
  if (sectionId || sectionName) {
    pick = avail.find((s) =>
      (s.available_sections || []).some(
        (x) => (sectionId && x.id === sectionId) || (sectionName && x.name === sectionName),
      ),
    );
    if (pick) sectionMatch = true;
  }
  if (!pick) pick = avail[0]; // backend sorts soonest-first
  const more = avail.length - 1;
  const date = showDate(pick.start_at);
  const message = sectionMatch
    ? `Can't wait? ${sectionName} seats are available for ${date}.`
    : `Can't wait? Tickets are available for ${date}.`;

  return (
    <div
      className="border-2 border-[var(--gt-ink)] bg-[var(--gt-bg-surface)] rounded-sm p-3 mb-3"
      data-testid="cross-sell-card"
    >
      <div className="flex items-start gap-2">
        <Ticket size={15} className="mt-0.5 shrink-0 text-[var(--gt-accent)]" />
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold" data-testid="cross-sell-message">{message}</div>
          {more > 0 && (
            <div className="text-xs text-[var(--gt-ink-3)] mt-0.5" data-testid="cross-sell-more">
              and {more} more date{more === 1 ? "" : "s"}
            </div>
          )}
        </div>
      </div>
      <Link
        to={`/e/${pick.slug}`}
        onClick={() => trackCrossSellClick(sourceEventId, pick.id, placement)}
        className="gt-btn-primary text-xs mt-2 inline-flex items-center gap-1.5 !py-2"
        data-testid="cross-sell-cta"
      >
        View available show <ArrowRight size={12} />
      </Link>
    </div>
  );
};

export default CrossSellCard;
